export const getIsPinned = (percentage: number): boolean => {
  if (!percentage) {
    return false
  }
  return percentage === 100
    ? true
    : Math.floor(Math.random() * 100) <= percentage
}
